import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LoginService } from "./login.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private loginService: LoginService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersFromLoginService = this.loginService.getHeaders();

    // Clona e adiciona os headers retornados pelo LoginService, preservando os existentes
    let updatedHeaders = req.headers;
    headersFromLoginService.keys().forEach((key) => {
      if (!updatedHeaders.has(key)) {
        updatedHeaders = updatedHeaders.set(
          key,
          headersFromLoginService.get(key)
        );
      }
    });

    const authReq = req.clone({ headers: updatedHeaders });

    return next.handle(authReq);
  }
}
